module.exports = __webpack_public_path__ + "img/重庆巫山大昌湖国家湿地公园@2x.872855e5.png";